const buildApiHost = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  const { protocol, hostname, port } = window.location;
  const backendHostname = hostname.startsWith('backend-') ? hostname : `backend-${hostname}`;
  const portSuffix = port ? `:${port}` : '';

  return `${protocol}//${backendHostname}${portSuffix}`;
};

const getInjectedApiHost = (): string => {
  if (typeof window === 'undefined') {
    return '';
  }
  const value = (document.getElementById('app') as HTMLElement | null)?.dataset.apiHost || '';
  return value.startsWith('_') ? '' : value.trim();
};

const configuredApiHost = (process.env.VUE_APP_API_HOST || '').trim();

export const VUE_APP_API_HOST = configuredApiHost || getInjectedApiHost() || buildApiHost() || '';